import React from "react";
import Tag from "@amzn/meridian/tag";
 
const ReceiveFilterTags = ({ items }) => {
    return (
        <div className="filter-tag">
            {items.map(item => (
                <Tag key={item} type="theme">{item}</Tag>
            ))}
        </div>
    );
};
 
export default ReceiveFilterTags;


// WEBPACK FOOTER //
// ./src/components/receive/ReceiveFilterTags.js